Vue.component('result-map', {
    props: ['result'],
    data() {
        return {
            //
        }
    },
    computed: {
        chartOptions() {
            var countries = [];
            this.result.process_data.forEach(row => {
                if (!row.country_of_origin) {
                    return;
                }
                if (!countries[row.country_of_origin]) {
                    countries[row.country_of_origin] = {
                        total : 0,
                        processes : [],
                    };
                }

                countries[row.country_of_origin]['total'] += Number(row.impact);
                countries[row.country_of_origin]['processes'].push({name : row.process, value: Number(row.impact)});
            });

            var chartData = [];
            var min = null;
            var max = null;
            for (const [country, data] of Object.entries(countries)) {
                this.getMapCountriesForCountry(country).forEach(mapCountry => {
                    chartData.push({name: mapCountry, value: data.total, processes : data.processes, country: country});
                });
                if (!min) {
                    min = data.total;
                }
                if (!max) {
                    max = data.total;
                }

                min = Math.min(data.total, min);
                max = Math.max(data.total, max);
            }

            // if the min and max are the same, the map coloring does not work well
            // let's make sure there is always a (even very small) difference.
            if (min == max) {
                min -= 0.001;
                max += 0.001;
            }

            return {
                series: [
                    {
                        name: "Map",
                        type: "map",
                        map: 'world',
                        data: chartData,
                        emphasis: {
                            label: {
                              show: false,
                            },
                            itemStyle: {
                                 areaColor: '#eeeeee',
                                 borderWidth: 2,
                                 borderColor: '#8e8e8e',
                            }
                        },
                    }
                ],
                visualMap: {
                    orient: 'horizontal',
                    itemHeight: '400',
                    min: min,
                    max: max,
                    inRange: {
                        color: [this.result.impact_driver.map_color_min, this.result.impact_driver.map_color_max]
                    },
                    text: [Vue.filter('result')(max), Vue.filter('result')(min)],
                },
                tooltip: {
                    trigger: 'item',
                    showDelay: 0,
                    transitionDuration: 0.2,
                    formatter: function (params) {
                        if (!params.data) {
                            return '';
                        }
                        var scores = [];
                        params.data.processes.forEach(process => {
                            scores.push(process.name + ' ≈ '+ Vue.filter('result')(process.value))
                        });

                        return '<strong>'+ params.data.country + '</strong><br/>' + scores.join('<br/>');
                    }
                },
            }
        },
    },
    methods: {
        getMapCountriesForCountry(country) {
            let mapping = {
                'RoW Europe' : ['Albania', 'Belarus', 'Bosnia and Herzegovina', 'Croatia', 'Iceland', 'Kosovo', 'Republic of Serbia', 'Macedonia', 'Ukraine', 'Moldova', 'Montenegro'],
                'RoW Asia and Pacific' : ['Kazakhstan', 'Pakistan', 'Georgia', 'Azerbaijan', 'Armenia', 'Japan', 'North Korea', 'New Zealand', 'Papua New Guinea', 'Philippines', 'Malaysia', 'Uzbekistan', 'Kyrgyzstan', 'Tajikistan', 'Turkmenistan', 'Afghanistan', 'Sri Lanka', 'Myanmar', 'Laos', 'Vietnam', 'Cambodia', 'Thailand', 'Nepal', 'East Timor', 'Vanuatu', 'Fiji', 'Solomon Islands', 'Mongolia'],
                'RoW Middle East' : ['Egypt', 'Saudi Arabia', 'Iraq', 'Yemen', 'Oman', 'Syria', 'Jordan', 'Iran', 'United Arab Emirates'],
                'RoW America' : ['Argentina', 'Chile', 'Uruguay', 'Paraguay', 'Bolivia', 'Peru', 'Ecuador', 'Colombia', 'Venezuela', 'Guyana', 'Suriname', 'Dominican Republic', 'Cuba', 'Haiti', 'Cuba', 'Guatemala', 'Honduras', 'Nicaragua', 'Panama', 'Costa Rica', 'El Salvador', 'Belize',],
                'RoW Africa' : ['Morocco', 'Algeria', 'Tunesia', 'Lybia', 'Sudan', 'Chad', 'Niger', 'Mali', 'Mauritania', 'Senegal', 'Burkina Faso', 'Nigeria', 'Benin', 'Ghana', 'Ivory Coast', 'Liberia', 'Sierra Leone', 'Western Sahara', 'Guinea', 'Guinea Bissau', 'Togo', 'Libya', 'Tunisia', 'Eritrea', 'Ethiopia', 'Somaliland', 'Somalia', 'Madagascar', 'Mozambique', 'Malawi', 'Zimbabwe', 'Lesotho', 'Swaziland', 'Botswana', 'Namibia', 'Angola', 'Zambia', 'Democratic Republic of the Congo', 'Republic of the Congo', 'Cameroon', 'Central African Republic', 'South Sudan', 'Kenya', 'Uganda', 'United Republic of Tanzania', 'Gabon', 'Equatorial Guinea', 'Burundi', 'Rwanda',],
                'Korea, Republic' : ['South Korea'],
                'Russian Federation' : ['Russia'],
                'Taiwan, Province of China' : ['China'],
                'United States' : ['United States of America'],
            };

            if (!mapping[country]) {
                return [country];
            }

            return mapping[country];
        }
    },
    mounted() {
        //
    }
});